(() => {
  const normalize = s => s?.toLowerCase().trim();

  function getOptionValue() {
    const checked =
      document.querySelector('.product-form__input input:checked + label');
    if (checked) return normalize(checked.innerText);

    const select =
      document.querySelector('.product-form__input select option:checked');
    if (select) return normalize(select.innerText);

    return null;
  }

  function filterMedia() {
    const option = getOptionValue();
    if (!option) return;

    const items = document.querySelectorAll('.product__media-item');

    let visible = 0;

    items.forEach(item => {
      const img = item.querySelector('img');
      if (!img) return;

      const alt = normalize(img.getAttribute('alt'));
      const show =
        alt?.includes(`variant:${option}`) ||
        alt?.includes('variant:all');

      // 🔑 THIS IS THE FIX — use hidden, NOT display:none
      item.hidden = !show;

      if (show) visible++;
    });

    // Fallback: show all if nothing matched
    if (visible === 0) {
      items.forEach(item => (item.hidden = false));
    }
  }

  // Dawn variant event
  document.addEventListener('variant:change', filterMedia);
  document.addEventListener('product:variant-change', filterMedia);

  // Initial load
  window.addEventListener('load', filterMedia);
})();
